import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { embedSearchWidgetViewVolopRoute } from '#/modules/embedSearchWidget/volops/routing/embedSearchWidgetVolops.routes';
import { importedEventRoute } from '#/modules/listing/routing/listing.routes';
import type { SearchAlgoliaHit } from '#/modules/search/algolia/types/SearchAlgoliaHit';

type Args = {
  result: SearchAlgoliaHit;
  embedSearchWidgetId: ApiEmbedSearchWidgetId | null;
  locale: I18nLocale;
};

export function searchContextHeaderGetUrl({
  result,
  embedSearchWidgetId,
  locale,
}: Args) {
  if (embedSearchWidgetId) {
    return embedSearchWidgetViewVolopRoute.with({
      lang: locale,
      embedSearchWidgetId,
      volopId: result.objectID,
    });
  }

  if (result.type === 'IMPORTED') {
    return importedEventRoute.with({
      lang: locale,
      source: result.source.toLowerCase(),
      eventId: result.objectID.replace(`${result.source}_`, ''),
    });
  }

  if (typeof result.url === 'string') return result.url;

  return result.url[locale];
}
